import React from 'react';
import PropTypes from 'prop-types';

import PromocodeInput from 'app/components/Form/PromocodeMobile';
import { Mobile, Desktop } from 'app/components/Responsive';

import ArrowRight from 'assets/svg/arrow_right.component.svg';
import LoadingIcon from 'app/components/LoadingIcon';

import './promocode-form.scss';


const locales = {
    ru: {
        apply: 'Применить',
        placeholder: 'Промокод',
    },
    en: {
        apply: 'Apply',
        placeholder: 'Promo-code',
    },
};


export default function PromocodeForm(props) {
    const {
        locale = 'ru',
        fillWidth = false,
        inputRef = { current: {} },
        promocode = '',
        isLoading = false,
        isValid = true,
        hasError = false,
        errorText = null,
        onChange,
        onSubmit,
    } = props;

    return (
        <form
            styleName="promocode"
            onSubmit={onSubmit}
        >
            <PromocodeInput
                fillWidth={fillWidth}
                value={promocode || ''}
                onChange={onChange}
                loading={isLoading}
                isValid={isValid}
                hasError={hasError}
                errorText={errorText}
                inputRef={inputRef}
                placeholder={locales[locale].placeholder}
            />
            <div styleName="promocode__input-icon">
                {isLoading && <LoadingIcon />}
            </div>
            <button
                type="submit"
                aria-label="Примерить промокод"
                styleName="promocode__button"
            >
                <Mobile>
                    <ArrowRight />
                </Mobile>
                <Desktop>
                    {locales[locale].apply}
                </Desktop>
            </button>
        </form>
    );
}

PromocodeForm.propTypes = {
    locale: PropTypes.string,

    fillWidth: PropTypes.bool,

    inputRef: PropTypes.shape({}),
    promocode: PropTypes.string,

    isLoading: PropTypes.bool,
    isValid: PropTypes.bool,
    hasError: PropTypes.bool,
    errorText: PropTypes.string,

    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
